import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNoticeableIrritationSelectedEmojiSecondary from './svgs/NoticeableIrritationSelectedEmojiSecondary.js';
import SvgNoticeableIrritationSelectedEmoji from './svgs/NoticeableIrritationSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var noticeableIrritationSelectedEmoji = (props => useIcon(SvgNoticeableIrritationSelectedEmoji, SvgNoticeableIrritationSelectedEmojiSecondary, props));

export { noticeableIrritationSelectedEmoji as default };
